import React from "react";
import {css, cx} from "@panda/css";

import {Badge} from "@pg-design/badge-module";
import {Text} from "@pg-design/text-module";

import ResponsiveCard from "../../../../atoms/responsive_card/ResponsiveCard";
import {useResponsiveLinkTarget} from "../../../../hooks/useResponsiveLinkTarget";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferGroupsSimplified} from "../../../../offer/detail/types/IOfferGroups";
import {getOfferTypeNamePlural} from "../../../../offer/helpers/OfferType";
import {OfferType} from "../../../../offer/types/OfferType";

interface IUnavailableOffer {
    id: number;
    name: string;
    region: {
        short_name: string;
    };
    slug: string;
    street_name: string | null;
    street_number: string | null;
    type: OfferType;
    groups: IOfferGroupsSimplified | null;
}

interface VendorDetailUnavailableOfferBoxProps {
    offer: IUnavailableOffer;
    vendorSlug: string;
    type: "archive" | "inactive";
}

export const VendorDetailUnavailableOfferBox: React.FC<VendorDetailUnavailableOfferBoxProps> = ({offer, vendorSlug, type}) => {
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const offerLink = useOfferLink({
        ...offer,
        vendor: {slug: vendorSlug}
    });

    const offerAddress = `${offer.region.short_name}, ${offer.street_name && `${offer.street_name} ${offer.street_number ? offer.street_number : ""}`}`;

    return (
        <a href={offerLink} className={cx(listItemStyle, type === "inactive" && disabledLinkStyle)} target={responsiveLinkTarget}>
            <ResponsiveCard>
                <ResponsiveCard.BodySimple className={cardBodyStyle}>
                    <div className={infoTextHolderStyle}>
                        <Text as="h3" variant="headline_5" className={titleStyle}>
                            {offer.name}{" "}
                            <Text as="span" variant="info_txt_1" className={noWrapStyle}>
                                ({getOfferTypeNamePlural(offer.type)})
                            </Text>
                        </Text>
                        <Text as="p" variant="body_copy_2" className={addressStyle}>
                            {offerAddress}
                        </Text>
                    </div>
                    <div className={cx(badgeHolderStyle, type === "inactive" && boldTextStyle)}>
                        <Badge variant="label_secondary" className={type === "inactive" ? grayBadgeStyle : undefined}>
                            {type === "archive" ? "Oferta archiwalna" : "Oferta nieaktywna"}
                        </Badge>
                    </div>
                </ResponsiveCard.BodySimple>
            </ResponsiveCard>
        </a>
    );
};

const cardBodyStyle = css({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%"
});

const infoTextHolderStyle = css({
    width: "100%",
    flex: "1 1 auto",
    md: {
        width: "auto"
    }
});

const titleStyle = css({
    marginBottom: 1
});

const addressStyle = css({
    marginBottom: 2
});

const noWrapStyle = css({
    whiteSpace: "nowrap",
    display: "block",
    md: {
        display: "inline-block"
    }
});

const badgeHolderStyle = css({
    alignSelf: "center",
    flex: "0 0 auto"
});

const listItemStyle = css({
    _hover: {
        textDecoration: "none",
        color: "var(--colors-secondary)"
    }
});

const disabledLinkStyle = css({
    pointerEvents: "none",
    color: "var(--colors-gray-700)",
    _hover: {
        color: "var(--colors-gray-700)"
    }
});

const boldTextStyle = css({
    "& p": {
        fontWeight: "bold"
    }
});

const grayBadgeStyle = css({
    backgroundColor: "var(--colors-gray-700) !important"
});
import React from "react";
import {css, cx} from "@panda/css";

import {Badge} from "@pg-design/badge-module";
import {Text} from "@pg-design/text-module";

import ResponsiveCard from "../../../../atoms/responsive_card/ResponsiveCard";
import {useResponsiveLinkTarget} from "../../../../hooks/useResponsiveLinkTarget";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferGroupsSimplified} from "../../../../offer/detail/types/IOfferGroups";
import {getOfferTypeNamePlural} from "../../../../offer/helpers/OfferType";
import {OfferType} from "../../../../offer/types/OfferType";

interface IUnavailableOffer {
    id: number;
    name: string;
    region: {
        short_name: string;
    };
    slug: string;
    street_name: string | null;
    street_number: string | null;
    type: OfferType;
    groups: IOfferGroupsSimplified | null;
}

interface VendorDetailUnavailableOfferBoxProps {
    offer: IUnavailableOffer;
    vendorSlug: string;
    type: "archive" | "inactive";
}

export const VendorDetailUnavailableOfferBox: React.FC<VendorDetailUnavailableOfferBoxProps> = ({offer, vendorSlug, type}) => {
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const offerLink = useOfferLink({
        ...offer,
        vendor: {slug: vendorSlug}
    });

    const offerAddress = `${offer.region.short_name}, ${offer.street_name && `${offer.street_name} ${offer.street_number ? offer.street_number : ""}`}`;

    return (
        <a href={offerLink} className={cx(listItemStyle, type === "inactive" && disabledLinkStyle)} target={responsiveLinkTarget}>
            <ResponsiveCard>
                <ResponsiveCard.BodySimple className={cardBodyStyle}>
                    <div className={infoTextHolderStyle}>
                        <Text as="h3" variant="headline_5" className={titleStyle}>
                            {offer.name}{" "}
                            <Text as="span" variant="info_txt_1" className={noWrapStyle}>
                                ({getOfferTypeNamePlural(offer.type)})
                            </Text>
                        </Text>
                        <Text as="p" variant="body_copy_2" className={addressStyle}>
                            {offerAddress}
                        </Text>
                    </div>
                    <div className={cx(badgeHolderStyle, type === "inactive" && boldTextStyle)}>
                        <Badge variant="label_secondary" className={type === "inactive" ? grayBadgeStyle : undefined}>
                            {type === "archive" ? "Oferta archiwalna" : "Oferta nieaktywna"}
                        </Badge>
                    </div>
                </ResponsiveCard.BodySimple>
            </ResponsiveCard>
        </a>
    );
};

const cardBodyStyle = css({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%"
});

const infoTextHolderStyle = css({
    width: "100%",
    flex: "1 1 auto",
    md: {
        width: "auto"
    }
});

const titleStyle = css({
    marginBottom: 1
});

const addressStyle = css({
    marginBottom: 2
});

const noWrapStyle = css({
    whiteSpace: "nowrap",
    display: "block",
    md: {
        display: "inline-block"
    }
});

const badgeHolderStyle = css({
    alignSelf: "center",
    flex: "0 0 auto"
});

const listItemStyle = css({
    _hover: {
        textDecoration: "none",
        color: "var(--colors-secondary)"
    }
});

const disabledLinkStyle = css({
    pointerEvents: "none",
    color: "var(--colors-gray-700)",
    _hover: {
        color: "var(--colors-gray-700)"
    }
});

const boldTextStyle = css({
    "& p": {
        fontWeight: "bold"
    }
});

const grayBadgeStyle = css({
    backgroundColor: "var(--colors-gray-700) !important"
});
